// Helper to add ordinal suffix (English only)
export const getOrdinalSuffix = (day) => {
  if (day >= 11 && day <= 13) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

// Welsh translations (manual fallback since browser might not handle it)
const welshWeekdays = ['Dydd Sul', 'Dydd Llun', 'Dydd Mawrth', 'Dydd Mercher', 'Dydd Iau', 'Dydd Gwener', 'Dydd Sadwrn'];
const welshMonths = ['Ionawr', 'Chwefror', 'Mawrth', 'Ebrill', 'Mai', 'Mehefin', 'Gorffennaf', 'Awst', 'Medi', 'Hydref', 'Tachwedd', 'Rhagfyr'];

// Format as: "Saturday 27th December 2026, 09:00-16:00" (English)
// or: "Dydd Sadwrn 27 Rhagfyr 2026, 09:00-16:00" (Welsh)
export const formatOpenDayDateTime = (start, end, lang = 'en') => {
  const day = start.getDate();
  const year = start.getFullYear();

  const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
  const startTimeStr = start.toLocaleTimeString('en-GB', timeOptions);
  const endTimeStr = end.toLocaleTimeString('en-GB', timeOptions);

  // Welsh - use manual translations for consistency
  if (lang === 'cy') {
    const weekday = welshWeekdays[start.getDay()];
    const month = welshMonths[start.getMonth()];
    return `${weekday} ${day} ${month} ${year}, ${startTimeStr}-${endTimeStr}`;
  }
  
  // English - use browser locale with ordinal suffix
  const weekday = start.toLocaleDateString('en-GB', { weekday: 'long' });
  const month = start.toLocaleDateString('en-GB', { month: 'long' });
  const daySuffix = getOrdinalSuffix(day);
  return `${weekday} ${day}${daySuffix} ${month} ${year}, ${startTimeStr}-${endTimeStr}`;
};
